/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrgCreateRequest } from '../models/OrgCreateRequest';
import type { OrgJoinRequest } from '../models/OrgJoinRequest';
import type { OrgMemberResponse } from '../models/OrgMemberResponse';
import type { OrgResponse } from '../models/OrgResponse';
import type { OrgUpdateRequest } from '../models/OrgUpdateRequest';
import type { PaginatedResponse_OrgResponse_ } from '../models/PaginatedResponse_OrgResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrganizationService {
    /**
     * Join Organization
     * 기관 가입
     *
     * 초대 코드를 통해 기관에 가입합니다.
     * 이메일에 해당하는 계정이 없으면 새로 생성하고, 이미 있으면 기관 멤버만 생성합니다.
     * @returns OrgMemberResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsJoinOrganization({
        requestBody,
    }: {
        requestBody: OrgJoinRequest,
    }): CancelablePromise<OrgMemberResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/org/join',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create Org
     * 기관 생성
     *
     * 새로운 기관을 생성합니다.
     * @returns OrgResponse Created
     * @throws ApiError
     */
    public static appsOrganizationViewsCreateOrg({
        requestBody,
    }: {
        requestBody: OrgCreateRequest,
    }): CancelablePromise<OrgResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/org',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Orgs
     * 기관 목록 조회 및 검색
     *
     * 모든 기관을 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * q: 검색 키워드 (선택사항) - 기관명으로 검색
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * @returns PaginatedResponse_OrgResponse_ OK
     * @throws ApiError
     */
    public static appsOrganizationViewsListOrgs({
        q,
        page = 1,
        perPage = 100,
    }: {
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_OrgResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/org',
            query: {
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Org
     * 기관 조회
     *
     * ID로 특정 기관을 조회합니다.
     * @returns OrgResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsGetOrg({
        orgId,
    }: {
        orgId: string,
    }): CancelablePromise<OrgResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/org/{org_id}',
            path: {
                'org_id': orgId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Org
     *     기관 정보 수정
     *
     * 특정 기관의 정보를 수정합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns OrgResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsUpdateOrg({
        orgId,
        requestBody,
    }: {
        orgId: string,
        requestBody: OrgUpdateRequest,
    }): CancelablePromise<OrgResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/org/{org_id}',
            path: {
                'org_id': orgId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Org
     *     기관 삭제
     *
     * 특정 기관을 삭제합니다. (소프트 삭제)
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsOrganizationViewsDeleteOrg({
        orgId,
    }: {
        orgId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/org/{org_id}',
            path: {
                'org_id': orgId,
            },
            errors: {
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload Org Logo Endpoint
     *     기관 로고 업로드
     *
     * 사이드바에 표시할 기관 로고 이미지를 올립니다. PNG·JPG·WEBP, 1MB 이하.
     * 이미 로고가 있으면 새 이미지로 바뀌고 예전 이미지는 지워집니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns OrgResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsUploadOrgLogoEndpoint({
        orgId,
        formData,
    }: {
        orgId: string,
        formData: {
            file: Blob;
        },
    }): CancelablePromise<OrgResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/org/{org_id}/logo',
            path: {
                'org_id': orgId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Delete Org Logo Endpoint
     *     기관 로고 삭제
     *
     * 올린 로고를 지우고 기본 DOT 로고로 되돌립니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns OrgResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsDeleteOrgLogoEndpoint({
        orgId,
    }: {
        orgId: string,
    }): CancelablePromise<OrgResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/org/{org_id}/logo',
            path: {
                'org_id': orgId,
            },
            errors: {
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Get Org Logo
     * 기관 로고 이미지 조회
     *
     * `<img>` 태그로 바로 쓰도록 이미지 바이트를 돌려줍니다. 인증 없이 열려 있습니다.
     * URL 의 `v` 값이 로고마다 달라지므로 오래 캐시해도 됩니다.
     * @returns void
     * @throws ApiError
     */
    public static appsOrganizationViewsGetOrgLogo({
        orgId,
    }: {
        orgId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/org/{org_id}/logo',
            path: {
                'org_id': orgId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Upload Org Favicon Endpoint
     *     기관 타이틀 로고 업로드
     *
     * 브라우저 탭에 표시할 아이콘(favicon)을 올립니다. PNG·JPG·WEBP·ICO, 1MB 이하.
     * 이미 있으면 새 이미지로 바뀌고 예전 이미지는 지워집니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns OrgResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsUploadOrgFaviconEndpoint({
        orgId,
        formData,
    }: {
        orgId: string,
        formData: {
            file: Blob;
        },
    }): CancelablePromise<OrgResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/org/{org_id}/favicon',
            path: {
                'org_id': orgId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Delete Org Favicon Endpoint
     *     기관 타이틀 로고 삭제
     *
     * 올린 타이틀 로고를 지우고 기본 아이콘으로 되돌립니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns OrgResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsDeleteOrgFaviconEndpoint({
        orgId,
    }: {
        orgId: string,
    }): CancelablePromise<OrgResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/org/{org_id}/favicon',
            path: {
                'org_id': orgId,
            },
            errors: {
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Get Org Favicon
     * 기관 타이틀 로고 이미지 조회
     *
     * `<link rel="icon">` 으로 바로 쓰도록 이미지 바이트를 돌려줍니다. 인증 없이 열려 있습니다.
     * URL 의 `v` 값이 이미지마다 달라지므로 오래 캐시해도 됩니다.
     * @returns void
     * @throws ApiError
     */
    public static appsOrganizationViewsGetOrgFavicon({
        orgId,
    }: {
        orgId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/org/{org_id}/favicon',
            path: {
                'org_id': orgId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
}
